import { graphql } from "../__generated__";

export const MUTATION_CREATE_PAYMENT = graphql(`
  mutation createPayment($input: PaymentInput!) {
    payForConsultation(input: $input)
  }
`);
